export default function Stats() {
  const stats = [
    { number: '5000+', label: 'Prodotti Disponibili' },
    { number: '850+', label: 'Clienti Soddisfatti' },
    { number: '24/48h', label: 'Consegna Garantita' },
    { number: '100%', label: 'Prodotti Originali' },
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-orange-500 to-orange-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl md:text-6xl font-black mb-3">
                {stat.number}
              </div>
              <div className="text-lg md:text-xl text-orange-100 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
